import React, { Component } from 'react';
import styled from 'styled-components';
import { translate } from 'react-i18next';
import CameraIcon from '@material-ui/icons/CameraAlt';
import QRScanner from './QRScanner';
import TextInput from '../fields/TextInput';
import theme from '../../theme';

const ScanError = styled.div`
  padding: 10px;
  text-align: center;
  color: ${theme.danger};
`;

const Wrapper = styled.div`
  display: flex;
  align-items: flex-end;
  align-content: center;
  width: 360px;
  margin: 30px auto 0px;
  padding: 5px;
`;

const InputWrapper = styled.div`
  flex-grow: 1;
  padding-left: 50px;
`;

const CameraButton = styled.button`
  width: 50px;
  height: 50px;
  background: none;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
`;

class QRIdInput extends Component {
  state = {
    scanning: false,
    error: '',
  };

  render() {
    return (
      <>
        <Wrapper>
          {this.state.scanning ? (
            <QRScanner
              onScan={result => {
                try {
                  const target = new URL(result);
                  if (target.origin === window.location.origin) {
                    this.setState(
                      {
                        scanning: false,
                        error: '',
                      },
                      () => {
                        this.props.onChange(target.pathname.replace(/^\//, ''));
                      }
                    );
                  } else {
                    this.setState({
                      error: 'errors.qr_scan_no_deviceid',
                    });
                  }
                } catch (e) {
                  // pass
                }
              }}
            />
          ) : (
            <>
              <InputWrapper style={{ flexGrow: 1 }}>
                <TextInput
                  value={this.props.input}
                  style={{ width: '100%' }}
                  onChange={event => {
                    this.props.onChange(event.target.value);
                  }}
                />
              </InputWrapper>
              <CameraButton onClick={() => this.setState({ scanning: true })}>
                <CameraIcon fontSize="large" style={{ fill: theme.primary }} />
              </CameraButton>
            </>
          )}
        </Wrapper>
        {this.state.scanning && this.state.error && (
          <ScanError>{this.props.t(this.state.error)}</ScanError>
        )}
      </>
    );
  }
}

export default translate()(QRIdInput);
